export const LoaderDraw = () => (
  <div className="relative mx-auto flex h-16 w-49.5 items-center justify-center">
    <svg
      className="absolute bottom-0 left-2.5 animate-mask-brush-line"
      width="146"
      height="24"
      viewBox="0 0 146 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.80885 14.8462C1.58424 16.054 0 14.604 0 12.884V9.96578C0 7.99169 0.941264 6.088 2.71069 5.21268C10.6416 1.28931 20.5027 2.60191 27.1422 9.15046C32.3311 14.2683 40.6689 14.2683 45.8578 9.15046C54.1618 0.960263 67.5049 0.960263 75.8089 9.15046C80.9978 14.2683 89.3356 14.2683 94.5245 9.15046C102.828 0.960263 116.172 0.960263 124.476 9.15046C129.664 14.2683 138.002 14.2683 143.191 9.15046C144.416 7.94263 146 9.39266 146 11.1127V14.0309C146 16.005 145.059 17.9087 143.289 18.784C135.358 22.7073 125.497 21.3947 118.858 14.8462C113.669 9.72835 105.331 9.72835 100.142 14.8462C91.8382 23.0364 78.4951 23.0364 70.1911 14.8462C65.0022 9.72835 56.6644 9.72835 51.4755 14.8462C43.1716 23.0364 29.8284 23.0364 21.5245 14.8462C16.3356 9.72835 7.99778 9.72835 2.80885 14.8462Z"
        fill="#E86F00"
      />
    </svg>
    <svg
      className="scale-110 animate-mask-brush"
      width="51"
      height="48"
      viewBox="0 0 51 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.25 4.375C50.75 4.875 51 5.5 51 6.25C51 7 50.75 7.625 50.25 8.125L26.375 32L19 24.625L42.875 0.75C43.375 0.25 44 0 44.75 0C45.5 0 46.125 0.25 46.625 0.75L50.25 4.375ZM8 31.75C9.58333 30.1667 11.4583 29.375 13.625 29.375C15.7917 29.375 17.6667 30.1667 19.25 31.75C20.8333 33.3333 21.625 35.2083 21.625 37.375C21.625 40.2917 20.5833 42.7917 18.5 44.875C16.4167 46.9583 13.9167 48 11 48C6.66667 48 3.125 46.2083 0.375 42.625C1.625 42.625 2.79167 42.1667 3.875 41.25C5.04167 40.25 5.625 38.9583 5.625 37.375C5.625 35.2083 6.41667 33.3333 8 31.75Z"
        fill="white"
      />
    </svg>
  </div>
);
